
import type { ComponentType } from 'react';
import { RouteComponentProps } from "react-router-dom";
import { History } from 'history';
import { IContainer, injectContainer } from "./container";

export interface IRouteComponentProps {
    history: any,
    location: any,
    match: any,
}

export interface IRouteActionResult {
    didLaunchAction: boolean;
    alternativeRouteRequested?: IRouteName,
    alternativeRoutePayload?: any;
}

export interface IRoute<T> {
    paths: string[];
    push: (history: History, props: T) => Promise<IRouteActionResult>;
    replace: (history: History, props: T) => Promise<IRouteActionResult>;
    component: ComponentType<RouteComponentProps<{}>>;
}

export interface IRouteComponentProps {
    history: any,
    location: any,
    match: any,
}

export enum IRouteName {
    Launch = "Launch",
    LanguageSelect = "LanguageSelect",
    TourSelect = "TourSelect",
    Tour = "Tour",
    SiteObject = "SiteObject",
    FloorPlan = "FloorPlan",
}

export interface IRouter {
    push: (name: IRouteName, history: any, args: any, options?: {replace?: boolean}) => void;
    popTo: (name: IRouteName, history: any, args: any) => boolean;
    pop: (history: any, args: any) => boolean;
    popCount: (num: number, history: any, args: any) => boolean;
    allRoutes: () => Array<IRoute<any>>;
}

const TYPES = {
    IRouter: Symbol.for("IRouter"),
}

export function injectRouter(container: IContainer = injectContainer()): IRouter {
    return container.get<IRouter>(TYPES.IRouter);
}

export function bindRouter(router: IRouter, container: IContainer = injectContainer()) {
    container.bind<IRouter>(TYPES.IRouter, router);
}
